import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { FelderService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [FelderService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class FelderServiceModule {}
